import React from 'react';

const Footer = ({ membersPath, communitiesPath }) => {
  return (
    <>
      <div className='marketplace-footer'>
        <div className='marketplace-footer-all-text-container'>
          <div className='marketplace-footer-links-container'>
            <div className='marketplace-footer-links-column-container'>
              <a className='marketplace-footer-link' href={membersPath}>Members</a>
              {/*
              <a className='marketplace-footer-link' href='#'>Partnerships</a>
              <a className='marketplace-footer-link' href='#'>FAQ</a>
              */}
            </div>
            <div className='marketplace-footer-links-column-container'>
              <a className='marketplace-footer-link' href={communitiesPath}>Communities</a>
              {/*
              <a className='marketplace-footer-link' href={props.careers_path}>Careers</a>
              <a className='marketplace-footer-link' href='#'>Contact</a>
              <a className='marketplace-footer-link' href='#'>Privacy</a>
              <a className='marketplace-footer-link' href='#'>Terms</a>
              */}
            </div>
          </div>
          <p className='marketplace-footer-copyright'>@ 2020 voray</p>
        </div>
      </div>
    </>
  );
};

export default Footer;
